import React from 'react';

const SeeMoreButton = ({ onClick }) => {
  return (
    <button className="see-more-btn" onClick={onClick}>
      See more
    </button>
  );
};

export default SeeMoreButton;
